import moment from 'moment';

class ExpensesController {

  constructor(AuthenticationService, CompanyService, toastr, $scope, $http, $rootScope, $state, $uibModal,
      DTOptionsBuilder, $q, DTColumnBuilder, $compile, TravelExpenseService) {
    'ngInject';

    const self = this;

    this.authenticationService = AuthenticationService;
    this.name = 'review';
    this.$http = $http;
    this.state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.travelExpenseService = TravelExpenseService;

    this.currentFilterRefresh = false;
    this.historyFilterRefresh = false;

    this.expenseMetrics = {
      openReports: 0,
      draftReports: 0,
      awaitingApproval: 0,
      actionRequired: 0,
      pendingReimbursement: 0,
      ytdReimbursed: 0
    };

    this.currentFilterCriteria = function() {
      return 'scope=current';
    };

    this.historyFilterCriteria = function() {
      return 'scope=history';
    };

    this.getCurrentExpenseRowClass = this.getCurrentExpenseRowClass.bind(this);

    this.currentExpenseColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'text',
        formatting(record) {
          const name = record.name || '';
          const proxy = self.proxyBadgeHtml(record);
          if (self.isRejectedStatus(record.status)) {
            return proxy
              + '<span class="rejected-report-flag" title="Rejected — action required"><i class="fa fa-times-circle"></i></span>'
              + '<a class="text-danger" style="cursor: pointer; font-weight: 600;">' + name + '</a>';
          }
          return proxy + '<a class="text-info" style="cursor: pointer;">' + name + '</a>';
        },
        clickFunction(record) {
          self.openExpenseReport(record);
        }
      },
      {
        displayName: 'Description',
        value: 'description',
        sortable: true,
        dataType: 'text'
      },
      {
        displayName: 'Type',
        value: 'purpose',
        sortable: true,
        dataType: 'text',
        formatting(record) {
          return self.getReportTypeLabel(record);
        }
      },
      {
        displayName: 'Date(s)',
        value: 'datesOfTravel',
        sortable: true,
        dataType: 'text',
        formatting(record) {
          return self.formatDatesOfTravel(record);
        }
      },
      {
        displayName: 'Estimated Amount',
        value: 'estimatedAmount',
        sortable: true,
        dataType: 'number',
        formatting(record) {
          return self.travelExpenseService.formatNumber(self.getEstimatedAmount(record));
        }
      },
      {
        displayName: 'Actual Amount',
        value: 'actualAmount',
        sortable: true,
        dataType: 'number',
        formatting(record) {
          return self.travelExpenseService.formatNumber(self.getActualAmount(record));
        }
      },
      {
        displayName: 'Status',
        value: 'status',
        sortable: true,
        dataType: 'text',
        formatting(record) {
          return self.formatStatusBadge(record.status);
        }
      },
      {
        displayName: '',
        value: 'id',
        sortable: false,
        dataType: 'text',
        formatting(record) {
          if (record.invoiced) {
            return '<span class="text-muted" title="Linked to an invoice — cannot delete"><i class="fa fa-lock"></i></span>';
          }
          return '<a class="text-danger" style="cursor: pointer;" title="Delete expense report"><i class="fa fa-trash"></i></a>';
        },
        clickFunction(record) {
          self.deleteExpenseReport(record);
        }
      }
    ];

    this.historyExpenseColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'text',
        formatting(record) {
          return self.proxyBadgeHtml(record)
            + '<a class="text-info" style="cursor: pointer;">' + (record.name || '') + '</a>';
        },
        clickFunction(record) {
          const states = self.getExpenseStatesForRecord(record);
          self.state.go(states.actuals, { expenseReportId: record.id });
        }
      },
      {
        displayName: 'Description',
        value: 'description',
        sortable: true,
        dataType: 'text'
      },
      {
        displayName: 'Type',
        value: 'purpose',
        sortable: true,
        dataType: 'text',
        formatting(record) {
          return self.getReportTypeLabel(record);
        }
      },
      {
        displayName: 'Date(s)',
        value: 'datesOfTravel',
        sortable: true,
        dataType: 'text',
        formatting(record) {
          return self.formatDatesOfTravel(record);
        }
      },
      {
        displayName: 'Amount',
        value: 'actualAmount',
        sortable: true,
        dataType: 'number',
        formatting(record) {
          return self.travelExpenseService.formatNumber(self.getActualAmount(record));
        }
      },
      {
        displayName: 'Status',
        value: 'status',
        sortable: true,
        dataType: 'text',
        formatting(record) {
          return self.formatStatusBadge(record.status);
        }
      },
      {
        displayName: '',
        value: 'id',
        sortable: false,
        dataType: 'text',
        formatting(record) {
          if (record.invoiced) {
            return '<span class="text-muted" title="Linked to an invoice — cannot delete"><i class="fa fa-lock"></i></span>';
          }
          return '<a class="text-danger" style="cursor: pointer;" title="Delete expense report"><i class="fa fa-trash"></i></a>';
        },
        clickFunction(record) {
          self.deleteExpenseReport(record);
        }
      }
    ];
  }

  getCurrentExpenseRowClass(record) {
    return this.isRejectedStatus(record.status) ? 'expense-row--rejected' : '';
  }

  onExpenseTableResponse(response) {
    if (response && response.metrics) {
      this.expenseMetrics = response.metrics;
    }
  }

  isGeneralBusiness(record) {
    return !!record && record.reportType === 'GENERAL_BUSINESS';
  }

  isOtherDirectCosts(record) {
    return !!record && record.reportType === 'OTHER_DIRECT_COSTS';
  }

  getReportTypeLabel(record) {
    if (this.isGeneralBusiness(record)) {
      return 'General Business';
    }
    if (this.isOtherDirectCosts(record)) {
      return 'Other Direct Costs';
    }
    return 'Travel';
  }

  getExpenseStatesForRecord(record) {
    if (this.isGeneralBusiness(record)) {
      return {
        create: 'general-business',
        details: 'general-business-details',
        actuals: 'general-business-actuals'
      };
    }

    if (this.isOtherDirectCosts(record)) {
      return {
        create: 'other-direct-costs',
        details: 'other-direct-costs-details',
        actuals: 'other-direct-costs-actuals'
      };
    }

    return {
      create: 'travel-expense',
      details: 'travel-expense-details',
      actuals: 'travel-expense-actuals'
    };
  }

  proxyBadgeHtml(record) {
    if (!record || !record.proxyCreatedByUserId) {
      return '';
    }
    const manager = [record.proxyCreatedByFirstName, record.proxyCreatedByLastName].filter(Boolean).join(' ')
      || 'a manager';
    return '<span class="label label-info" style="margin-right: 6px;" title="Entered by '
      + manager + ' on behalf of you">Proxy</span>';
  }

  openExpenseReport(record) {
    const status = (record.status || '').toUpperCase();
    const states = this.getExpenseStatesForRecord(record);

    if (status === 'DRAFT') {
      this.state.go(states.create, { expenseReportId: record.id });
      return;
    }

    if (status === 'SUBMITTED' || status === 'REJECTED') {
      this.state.go(states.details, { expenseReportId: record.id });
      return;
    }

    if (
      status === 'APPROVED'
      || status === 'REIMBURSEMENT_REQUESTED'
      || status === 'REIMBURSEMENT_REJECTED'
      || status === 'REIMBURSEMENT_APPROVED'
      || status === 'PROCESSED'
    ) {
      this.state.go(states.actuals, { expenseReportId: record.id });
    }
  }

  formatDatesOfTravel(record) {
    if (record.datesOfTravel) {
      return record.datesOfTravel;
    }

    if (record.expenses && record.expenses.length) {
      return this.travelExpenseService.getDatesOfTravel(record);
    }

    return '';
  }

  getEstimatedAmount(record) {
    if (record.estimatedAmount != null) {
      return record.estimatedAmount;
    }

    if (record.expenses && record.expenses.length) {
      return this.travelExpenseService.getEstimatedTotalForExpenseReport(record);
    }

    return 0;
  }

  getActualAmount(record) {
    if (record.actualAmount != null) {
      return record.actualAmount;
    }

    if (record.expenses && record.expenses.length) {
      return this.travelExpenseService.getActualTotalForExpenseReport(record);
    }

    return 0;
  }

  getStatus(status) {
    const statusDetails = this.travelExpenseService.getTravelExpenseStatusDetails(status);
    return statusDetails ? statusDetails.label : '';
  }

  isRejectedStatus(status) {
    const normalized = (status || '').toUpperCase();
    return normalized === 'REJECTED'
      || normalized === 'REIMBURSEMENT_REJECTED'
      || normalized === 'REIMBURSMENT_REJECTED';
  }

  formatStatusBadge(status) {
    const label = this.getStatus(status) || status || '';
    if (!label) {
      return '';
    }

    if (this.isRejectedStatus(status)) {
      return '<span class="expense-status-badge expense-status-badge--rejected">'
        + '<i class="fa fa-times-circle"></i> ' + label
        + '</span>';
    }

    return '<span class="expense-status-badge expense-status-badge--default">' + label + '</span>';
  }

  deleteExpenseReport(record) {
    if (!record || !record.id || record.invoiced) {
      if (record && record.invoiced) {
        this.toastr.warning('This expense report is on an invoice and cannot be deleted.', 'Cannot Delete');
      }
      return;
    }

    const name = record.name || 'this expense report';
    if (!window.confirm('Delete "' + name + '"? This cannot be undone.')) {
      return;
    }

    this.travelExpenseService.deleteExpenseReport(record.id).then(() => {
      this.toastr.success('Expense report deleted.', 'Deleted');
      this.currentFilterRefresh = true;
      this.historyFilterRefresh = true;
    }, (error) => {
      const message = (error.data && (error.data.message || error.data.error))
        || 'Could not delete expense report.';
      this.toastr.error(message, 'Error');
    });
  }
}

export default ExpensesController;



// WEBPACK FOOTER //
// ./client/pages/expenses/expenses.controller.js